<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$input",
					"field": "goodscode",
					"title": "产品编码",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "boxgauge",
					"title": "盒规",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":0,
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "bingauge",
					"title": "箱规",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":0
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				// {
				// 	"type": "$datePicker",
				// 	"field": "time",
				// 	"title": "time",
				// 	"props": {
				// 		"type": "date",
				// 		"disabled":true
				// 	},
				// 	"value": null,
				// 	"hidden": false,
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// },
				// {
				// 	"type": "$emun",
				// 	"field": "emun",
				// 	"title": "emun",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {
				// 		"name": "enable"
				// 	},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// },
				// {
				// 	"type": "$upload",
				// 	"field": "upload",
				// 	"title": "upload",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// }
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			crmcustomerwlnid:{
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading:false,
				modal_model:false,
				modal_title: '编辑',
				modal_width:600,
				modal_height:500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init(){
				this.sourceData = JSON.parse(JSON.stringify(this.data))
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					submitData.wlnid = this.crmcustomerwlnid
					this.submitDataFormater(submitData)
					this.loading = true
					this.$api.crmcustomerwecom.updategoods(submitData).then(()=>{
						this.loading = false
						this.$emit('submit')
						this.modal_cancel()
					},()=>{
						this.loading = false
					})
					// console.log(submitData)
					
					
				}, (fApi) => {
					fApi.validate((valid, errors) => {
						if (!valid) {
							let arr = []
							for(let i in errors){
								errors[i].forEach((item)=>{
									arr.push(item.message)
								})
							}
							if(arr.length){
								this.message.error(arr[0])
							}
						}
					})
				})
				//this.init()
			},
			createDetail(data){
				data = JSON.parse(JSON.stringify(data))
				data.forEach((item)=>{
					delete(item['_X_ROW_CHILD'])
					delete(item['_X_ROW_KEY'])
				})
				return data
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>